/**
 * Strip HTML tags from a string
 * @param {String} html
 * @return {String | null} Returns the stripped string.
 */
const stripTags = (html: string): string | null => {
  const document = new DOMParser().parseFromString(html, 'text/html');
  return document.body.textContent;
};

export default stripTags;
